/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
import PRM from "@/core/PermissionConstants";
export default {
  path: "/app/config/hallazgos",
  name: "MAMA-FINDING",
  component: () => import("@/app/views/crud/CrudSimpleView.vue"),
  meta: {
    service: () => import("@/app/services/MastographyFindingService"),
    table: () => import("@/app/components/config/mastography/MamaFindingTable.vue"),
    form: () => import("@/app/components/config/mastography/MamaFindingForm.vue"),
    header: {
      icono: "mdi-clipboard-text-outline",
      texto: "Hallazgos",
      textNew: "Nuevo hallazgo",
      textEdit: "Editar hallazgo",
    },
    
    requireAuth: true,
    hideButtonAdd: false,
    addButtonText: "AGREGAR HALLAZGO",
  },
};